import React from 'react';

// ant
import { Table, Card, Button, Input, Space } from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  KeyOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';

// lodash
import get from 'lodash.get';
import isequal from 'lodash.isequal';

// components
import ButtonTooltip from '../common/ButtonTooltip';
import ButtonPopconfirm from './../common/ButtonPopconfirm';

const { Column } = Table;

class UsuariosTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
  };

  // filtrar objetos
  // https://stackoverflow.com/questions/61715226/antd-table-getcolumnsearchprops-broken-with-nested-object

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      get(record, dataIndex)
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      isequal(this.state.searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    return (
      <Card
        title="Usuarios"
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={this.props.addUsuario}
          >
            Agregar
          </Button>
        }
      >
        <Table
          dataSource={this.props.usuarios}
          size="small"
          width="auto"
          height="auto"
          pagination={{ pageSize: 20 }}
          scroll={{ x: 1000 }}
          rowKey="Id"
        >
          <Column
            title="Nombre"
            dataIndex="Nombre"
            {...this.getColumnSearchProps('Nombre')}
          />
          <Column
            title="Teléfono"
            dataIndex="Telefono"
            {...this.getColumnSearchProps('Telefono')}
          />
          <Column
            title="Correo"
            dataIndex="Correo"
            {...this.getColumnSearchProps('Correo')}
          />
          <Column
            title="Departamento"
            dataIndex={['departamento', 'Nombre']}
            {...this.getColumnSearchProps(['departamento', 'Nombre'])}
          />
          <Column
            title="Estado"
            dataIndex="Estado"
            {...this.getColumnSearchProps('Estado')}
          />
          <Column
            title="Rol"
            dataIndex={['role', 'Nombre']}
            {...this.getColumnSearchProps(['role', 'Nombre'])}
          />
          <Column
            title="Acciones"
            width={150}
            fixed="right"
            render={(text, record) => (
              <>
                <ButtonTooltip
                  icon={EditOutlined}
                  title="Editar"
                  onClick={() => this.props.editUsuario(record)}
                />
                <ButtonTooltip
                  icon={KeyOutlined}
                  title="Cambiar password"
                  onClick={() => this.props.editPassword(record)}
                />
                <ButtonPopconfirm
                  icon={DeleteOutlined}
                  title="¿Desea eliminar el usuario seleccionado?"
                  tooltip="Eliminar"
                  onConfirm={() => this.props.deleteUsuario(record.Id)}
                />
              </>
            )}
          />
        </Table>
      </Card>
    );
  }
}

UsuariosTable.defaultProps = {};

UsuariosTable.propTypes = {};

export default UsuariosTable;
